module.exports = __webpack_public_path__ + "assets/c3cd79c45b666a77667943898dcb0103.jpg";